import {
    infoHeader, infoMessage,
} from './styles'

import React from 'react'
import {styled} from 'stitches/config'

const StyledInfoMessage = styled('div', infoMessage)
const StyledInfoHeader = styled('div', infoHeader)

export interface InfoMessageProps {
    icon: React.ComponentType
    infoHeader?: string
    message: string | React.ReactNode
    variant?: 'default' | 'warning' | 'error' | 'success'
    onModal?: boolean
}

export const InfoMessage: React.FC<InfoMessageProps> = ({
    icon: Icon, infoHeader: headerText, message, variant, onModal,
}) => (
    <StyledInfoMessage onModal={onModal} variant={variant}>
        <div>
            <Icon />
        </div>
        <div>
            {headerText ? <StyledInfoHeader>{headerText}</StyledInfoHeader> : null}
            <div>{message}</div>
        </div>
    </StyledInfoMessage>
)

InfoMessage.defaultProps = {
    infoHeader: undefined,
    onModal: false,
    variant: 'default',
}
